import { render, staticRenderFns } from "./socialMobile3_ok.vue?vue&type=template&id=5b0bf204&scoped=true"
import script from "./socialMobile3_ok.vue?vue&type=script&lang=js"
export * from "./socialMobile3_ok.vue?vue&type=script&lang=js"
import style0 from "./socialMobile3_ok.vue?vue&type=style&index=0&id=5b0bf204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bf204",
  null
  
)

export default component.exports